<template>
  <div class="container">
    <!-- breadcrumb area end -->

     <at-collapse accordion :value="0" >
        <at-collapse-item v-bind:name="'mnu' + item.CategoryID"  v-for="item in this.$store.getters.allCategories" v-bind:style="{ 'background-color': getColorApp}">
          <div slot="title" v-bind:style="{ 'background-color': getColorApp}">{{item.Title}}</div>
          <div>
              <div v-if="item.SubCat.length > 0" v-for="submenu in item.SubCat">
                  <at-collapse accordion :value="0" v-bind:name="'submnublock' + item.CategoryID">
                      <at-collapse-item v-bind:name="'subcat' + submenu.CategoryID" v-bind:style="{ 'background-color': getColorApp}" style="margin-bottom: 2px;">
                         <div slot="title">{{submenu.Title}}</div>
                         <div>
                           <div class="row at-row no-gutter bottomline" v-for="subserv in submenu.Services">
                              <div :class="'col-16'">
                                
                                <div v-if="subserv.IsPackage"><at-badge value="PAKKET"></at-badge>&nbsp;<strong>{{ subserv.Title }}</strong>
                                    <ul>
                                          <template v-for="serv in subserv.Childs">
                                              <li> - {{serv.Title}}</li>
                                          </template>
                                        </ul>
                                </div>
                                <div v-else>{{ subserv.Title }}</div>
                                <span v-if="subserv.Detail.length > 1"><small>{{subserv.Detail}}</small></span>
                              </div>
                              <div :class="'col-3'"><div class="at-box-row bg-c-brand-light"> {{ subserv.IntDuration }} min.</div></div>
                              <div :class="'col-3'"><div class="at-box-row bg-c-brand-light"><span v-if="!getPrice"> € {{ subserv.Price }}</span></div></div>
                              <div :class="'col-2'"><div class="at-box-row bg-c-brand-light"> 
                                <at-button size="smaller" icon="icon-chevron-right" circle @click="addToCart (subserv)"></at-button></div></div>
                            </div>

                         </div>
                      </at-collapse-item>
                  </at-collapse>
              </div>
              <div else>
              </div>
               
               <div class="row at-row no-gutter bottomline" v-for="serv in item.Services">
                  <div :class="'col-1'"></div>
                  <div :class="'col-15'">

                    <div v-if="serv.IsPackage"><at-badge value="PAKKET"></at-badge>&nbsp;<strong>{{ serv.Title }}</strong>
                        <ul>
                          <template v-for="serv2 in serv.Childs">
                              <li> - {{serv2.Title}}</li>
                          </template>
                        </ul>
                    </div>
                    <div v-else>{{ serv.Title }}</div>
                    <span v-if="serv.Detail.length > 1"><small>{{serv.Detail}}</small></span>
                  </div>

                  <div :class="'col-3'"><div class="at-box-row bg-c-brand-light"> {{ serv.IntDuration }} min.</div></div>
                  <div :class="'col-3'"><div class="at-box-row bg-c-brand-light"><span v-if="!getPrice">€ {{ serv.Price }}</span></div></div>
                  <div :class="'col-2'"><div class="at-box-row bg-c-brand-light"><at-button size="smaller" icon="icon-chevron-right" circle @click="addToCart (serv)"></at-button></div></div>
                </div>

          </div>
        </at-collapse-item>
      </at-collapse>
   
  </div>
</template>



<script>
import myHttpApi from "../api/myhttpapi";
import Vue from 'vue';
import AtComponents from 'at-ui'
import 'at-ui-style'    // Import CSS

  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../store/mutation-types'

  Vue.use(AtComponents)

  export default {
    name: 'home',
    components: {

    },
     data () {
      return {
         items: [],
      }
    },
    created () {
    
      this.styleControls ();
    },
    updated: function () {
       this.styleControls ();
       document.title = "Reserveer online bij " + Vue.$storeSettings.StoreName
    },
    methods: {
     
      addToCart (product) {
        
        if (this.hasPackageData (product))
        {
           for (var i = 0; i < product.Childs.length; i++)
           {
              var a = product.Childs[i];
              a.PackageID = product.ArticleID;
              this.$store.commit(ADD_TO_CART, a)
           }
        }
        else
        {
           this.$store.commit(ADD_TO_CART, product)
        }
        
        this.$router.push ("/cart");
      },
      hasPackageData (product) {
         if (product.Childs == null) {return false;}
         if (product.Childs.length > 0) {return true;}
         return false;
       },
       styleControls () {
            
            let childElements = [...document.querySelectorAll('.at-collapse__header')];
            childElements.map(element => {
              element.style.backgroundColor = 'transparent'; 
              element.style.color = '#fff'; 
            });

            let childElements2 = [...document.querySelectorAll('.at-collapse')];
            childElements2.map(element => {
              element.style.backgroundColor = '#fff'; 
              element.style.borderRadius = '10px'; 
              element.style.border = '0px'; 
            });

            let childElements3 = [...document.querySelectorAll('.at-collapse__icon')];
            childElements3.map(element => {
              element.style.color = '#fff';  
            });
       }
    },
    computed: {
       getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
       getPrice () {
          if (Vue.$storeSettings == undefined)
          {
            return true;
          }

          return Vue.$storeSettings.IsHidePrices;
       }
    },
    ready() {
      
    },
    mounted() {
     
       this.styleControls ();

    },
  }
</script>

<style>

</style>






// WEBPACK FOOTER //
// src/pages/CategoriesList.vue